// Battle Royale Game Types

export interface Player {
  id: string;
  displayName: string;
  tableNumber: number;
  teamColor: TeamColor;
  ownAnswerId: string; // OP謎の答えID
  answeredIds: string[]; // 回答済みの問題ID配列（チュートリアル含む）
  score: number; // answeredIds.lengthと同じ値
  lastCorrectAt?: Date;
  createdAt: Date;
}

export interface Team {
  color: TeamColor;
  displayName: string;
  colorCode: string;
  totalScore: number;
  scorePercentage: number;
}

export enum TeamColor {
  RED = 'red',
  BLUE = 'blue',
  GREEN = 'green',
  YELLOW = 'yellow',
  PURPLE = 'purple',
  ORANGE = 'orange'
}

export interface Answer {
  id: string;
  canonical: string;
  synonyms: string[];
  points: number;
}

export interface Submission {
  id: string;
  playerId: string;
  answerId: string;
  answerText: string;
  isCorrect: boolean;
  points: number;
  submittedAt: Date;
  isDuplicate: boolean;
}

export enum GameState {
  WAITING = 'waiting',
  PLAYING = 'playing',
  ENDED = 'ended'
}

export interface GameSession {
  id: string;
  name: string;
  state: GameState;
  answers: Answer[];
  teams: Team[];
  startedAt?: Date;
  endedAt?: Date;
  settings: GameSettings;
}

export enum ScreenMode {
  GROUP_6 = 'group-6',     // グループランキング（1-6位）
  GROUP_4 = 'group-4',     // グループランキング（1-4位）
  GROUP_3 = 'group-3',     // グループランキング（1-3位）
  INDIVIDUAL = 'individual', // 個人ランキング
  QR_CODE = 'qr-code'      // QRコード表示
}

export interface GameSettings {
  pointsPerCorrect: number;
  rateLimit: number; // submissions per minute
  tableCount: number;
  opAnswerMappings: Record<string, TeamColor>; // OP答え -> チーム色
  showTop3Only?: boolean; // true: 1-3位のみ表示、false/undefined: 1-6位まで表示
  screenMode?: ScreenMode; // スクリーン表示モード
}

export interface PlayerStats {
  playerId: string;
  displayName: string;
  score: number;
  correctCount: number;
  lastCorrectAt?: Date;
  teamColor: TeamColor;
}

export interface TeamStats {
  teamColor: TeamColor;
  totalScore: number;
  scorePercentage: number;
  playerCount: number;
}